import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod/v3'
import { AppContainer } from '~/components/new/app-ui/app-container'
import { AppHeader } from '~/components/new/app-ui/app-header'
import { Title } from '~/components/new/app-ui/title'
import { CameraViewForm } from '~/components/routes/cameras/camera-views/camera-view-form'
import { CAMERA_STREAM_ADD } from '~/components/routes/cameras/permissions'
import { api } from '~/lib/tuyau'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/cameras-views/new')({
  staticData: {
    permission: CAMERA_STREAM_ADD,
  },
  component: CameraViewCreatePage,
  validateSearch: z.object({
    returnTo: z.enum(['legacy', 'new']).optional(),
  }),
})
withRoutePermissions(Route)

function CameraViewCreatePage() {
  const navigate = Route.useNavigate()
  const { returnTo } = Route.useSearch()
  const queryClient = useQueryClient()
  const createCameraView = useMutation(
    api.cameraViews.create.mutationOptions({
      onSuccess: () => queryClient.invalidateQueries(api.cameraViews.list.queryFilter()),
    }),
  )

  return (
    <>
      <AppHeader>
        <Title>Nouvelle vue caméras</Title>
      </AppHeader>

      <AppContainer className="flex-1 min-h-0">
        <CameraViewForm
          submitPermission={CAMERA_STREAM_ADD}
          onSave={(values) => {
            createCameraView.mutate(
              { body: values },
              {
                onSuccess: (created) => {
                  if (returnTo === 'new') {
                    navigate({
                      to: '/cameras/new',
                      search: { mode: 'views', viewId: created.id },
                    })
                  } else {
                    navigate({ to: '/cameras-views', search: { viewId: created.id } })
                  }
                },
              },
            )
          }}
          onCancel={() => {
            if (returnTo === 'new') {
              navigate({ to: '/cameras/new', search: { mode: 'views' } })
            } else {
              navigate({ to: '/cameras-views' })
            }
          }}
        />
      </AppContainer>
    </>
  )
}
